//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { ReportFormat, ReportStatus } from './Enums';

export class ReportDisplayItem extends ItemBase {
    CreateDate: string = "1970-01-01T00:00:00";
    DownloadURL: string | null = null;
    EndDate: string | null = null;
    Format: ReportFormat = ReportFormat.PDF;
    Archived: boolean = false;
    ID: string | null = null;
    Name: string | null = null;
    Note: string | null = null;
    SingleUse: boolean = false;
    StartDate: string | null = null;
    Status: ReportStatus = ReportStatus.Completed;
    ViewURL: string | null = null;

    constructor(initializer?: Partial<ReportDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "ReportDisplayItem";
}
